// @ts-ignore - no types
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

export interface TypesenseConfigInput {
  host: string;
  apiKey: string;
}

export function createTypesensePartSearchAdapter(config: TypesenseConfigInput | null) {
  try {
    if (!config?.host || !config?.apiKey) return null;
    return new TypesenseInstantSearchAdapter({
      server: {
        nodes: [{ host: config.host, port: 443, protocol: "https" }],
        apiKey: config.apiKey,
      },
      additionalSearchParameters: { query_by: "partName,partNumber" },
    });
  } catch {
    return null;
  }
}

export function mapTypesenseHitToBackendFormat(part: any) {
  const src = part?.document ? { ...part, ...part.document } : part;
  return {
    ...src,
    _id: src._id || src.partId || part._id,
    _highlightResult: part._highlightResult,
  };
}

export async function searchPartsInTypesense(
  adapter: any,
  partNumber: string,
  page = 1,
  limit = 20
) {
  try {
    const results = await adapter.searchClient.search([
      {
        indexName: "partmasters",
        params: { query: partNumber.trim(), hitsPerPage: limit, page: page - 1 },
      },
    ] as any);
    return (results as any).results?.[0]?.hits ?? [];
  } catch {
    return [];
  }
}
